import whenDomReady from 'when-dom-ready';

const ACTIVE = 'is-active';

function handleLinkClick(e) {
  const item = e.currentTarget;
  const navUrl = item.dataset.href;

  window.history.pushState({ url: navUrl }, '', navUrl);
}

function initialise() {
  const accountNavItems = document.querySelectorAll('.js-account-navigate');

  if (accountNavItems.length) {
    Array.forEach(accountNavItems, accountNavItem => {
      const navUrl = accountNavItem.dataset.href;

      if (window.location.href.indexOf(navUrl) !== -1) {
        accountNavItem.classList.add(ACTIVE);
      }

      accountNavItem.addEventListener('click', handleLinkClick);
    });
  }

  bindMobileNav();
}

function bindMobileNav() {
  if (window.matchMedia('(min-width: 992px)').matches) {
    return;
  }

  const footer = document.querySelector('.js-footer');
  const nav = document.querySelector('.js-my-account-nav');

  // Add the padding to the content on page load
  const content = document.querySelector('.js-my-account');

  if (content === null) {
    return;
  }

  content.style.paddingBottom = `${nav.clientHeight}px`;

  // Create callback
  const onObserve = entries => {
    Array.forEach(entries, entry => {
      if (entry.isIntersecting) {
        nav.classList.add('sticky');
      } else {
        nav.classList.remove('sticky');
      }
    });
  };

  // Create observer
  const observer = new IntersectionObserver(onObserve, {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  });

  // Observe footer
  observer.observe(footer);
}

whenDomReady().then(initialise);

Sys.WebForms.PageRequestManager.getInstance().add_endRequest(initialise);
